const currencyFormatter = (number: number, decimal: number = 2) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency', 
        currency: 'USD', 
        minimumFractionDigits: decimal 
    }).format(number)
}

export default currencyFormatter